import React from 'react';
import { useTranslation } from 'react-i18next';
import './About.css';
import aboutImage from '../assets/aboutPageBanner.jpg';

function About() {
    const { t } = useTranslation();

    return (
        <div className="about-container">
            <div className="about-text-section top-text">
                <p>
                    <span className="red">{t('about.line1')}</span> {t('about.line2')}
                </p>
                <p>{t('about.line3')}</p>
                <p>{t('about.line4')}</p>
                <p>
                    <span className="red">{t('about.line5a')}</span> {t('about.line5b')}{' '}
                    <span className="red">{t('about.line5c')}</span> {t('about.line5d')}{' '}
                    <span className="red">{t('about.line5e')}</span> {t('about.line5f')}
                </p>
                <p>
                    {t('about.line6')}<br /><br />
                    {t('about.line7')}
                </p>
            </div>

            <img src={aboutImage} alt="BitLife Preview" className="about-banner" />

            <div className="about-text-section bottom-text">
                <p>{t('about.bottom1')}</p>
                <p><span className="red">{t('about.bottom2')}</span></p>
            </div>
        </div>
    );
}

export default About;
